import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'devextreme-react/button';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '2rem',
        backgroundColor: '#f8f9fa'
      }}
    >
      <div style={{ fontSize: '6rem', fontWeight: 'bold', color: '#dc3545' }}>404</div>
      <h2 style={{ fontSize: '2rem', margin: '1rem 0', color: '#343a40' }}>
        Página no encontrada
      </h2>
      <p style={{ fontSize: '1.1rem', marginBottom: '2rem', color: '#6c757d' }}>
        Lo sentimos, la página que estás buscando no existe o fue movida.
      </p>
      <Button
        text="Volver al inicio"
        type="normal"
        stylingMode="contained"
        onClick={handleGoHome}
      />
    </div>
  );
};

export default NotFound;
